import React from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';

import { productIsAllGroup } from '../../imageRecords';

const GroupPhotoHeading = styled.h6`
  text-align: center;
  margin-bottom: 16px;
  font-size: 14px;
`;

const StudentGroupImageComponent: React.FC = () => {
  const product = useSelector(
    (state: any) => state.productConfig.currentProduct,
  );
  const poseSelections = useSelector(
    (state: any) => state.productConfig.poseSelections,
  );
  const { selectedStudent, studentGroupImages } = useSelector(
    (state: any) => state.additionalData,
  );

  // A pure group product (every record is a group photo) shows the selected
  // group image inline; mixed and individual products fall back to the
  // student's group image preview.
  const isGroupImage = productIsAllGroup(product);
  const studentGroupImage = isGroupImage
    ? poseSelections[0] || {}
    : (studentGroupImages && studentGroupImages[0]) || {};

  const studentFirstName =
    selectedStudent?.firstName || selectedStudent?.first_name || null;
  const studentLastName =
    selectedStudent?.lastName || selectedStudent?.last_name || null;
  const hasStudent = studentFirstName && studentLastName;

  if (!isGroupImage || !studentGroupImage?.url) {
    return null;
  }

  const studentName = hasStudent
    ? `${studentFirstName} ${studentLastName}`
    : `Your student`;

  return <GroupPhotoHeading>{studentName}'s group photo:</GroupPhotoHeading>;
};

export default StudentGroupImageComponent;
